
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/

export function isValidEmail (email) {
  return EMAIL_REGEX.test((email || '').trim())
}

export const emailRules = [
  v => !!v || 'Este campo es obligatorio',
  v => isValidEmail(v) || 'Ingrese un correo electronico valido',
]


